import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";

export interface FinanceAnalyticsFilters {
  order_id: FilterValue[] | null;
  customer_id: FilterValue[] | null;
  start_date: Dayjs;
  end_date: Dayjs;
}

export interface FinanceAnalyticsSelectedFilters {
  order_id: FilterValue[] | null;
  customer_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export interface FinanceAnalyticsAPIFilters {
  order_id: FilterValue[] | null;
  customer_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export function parseQueryParamsForFinanceAnalyticsFilters(
  params: FinanceAnalyticsFilters | null,
  query_params: URLSearchParams
): FinanceAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    order_id: params?.order_id ?? [],
    customer_id: params?.customer_id ?? [],
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
  };
}
